export default __webpack_public_path__ + "static/media/apvs-arte-5.6ca09116.webp";